// xmas点击tab跳转对应模块
let currentPage = window.location.href
if(currentPage.search('/xmas-sale-2024') != -1){
  $(function(){
    let fixedTypeName = ''
    setTimeout(()=>{
        $(".AKXmasTab_fixed ul li").click(function(){
          $(this).addClass("active").siblings().removeClass("active")
          fixedTypeName = $(this).attr("data-type")
          $('html,body').animate({scrollTop:$(`#${fixedTypeName}`).offset().top-110}, 800);
      })
    },800)
  })
}

// header 菜单鼠标悬浮
$(function(){
  function setMegaMenuTop() {
    var $wrapper = $('.header-wrapper');
    if (!$wrapper.length) return;
    var bottom = $wrapper[0].getBoundingClientRect().bottom;
    document.documentElement.style.setProperty('--site-header-bottom', bottom + 'px');
  }

  function loadMegaMenuProductImages() {
    var $links = $('.header--desktop .main-menu-child a[data-menu-product-handle]');
    if (!$links.length) return;

    function applyImageMap(map) {
      $links.each(function() {
        var handle = this.getAttribute('data-menu-product-handle');
        var src = map[handle];
        if (!src) return;
        var img = this.querySelector('img[data-menu-product-image]') || this.querySelector('img');
        if (!img) {
          img = document.createElement('img');
          img.setAttribute('data-menu-product-image', '');
          img.alt = '';
          this.insertBefore(img, this.firstChild);
        }
        img.src = src;
      });
    }

    function fetchMissingHandles(map, handles) {
      var missing = handles.filter(function(handle) { return !map[handle]; });
      if (!missing.length) {
        applyImageMap(map);
        return;
      }
      Promise.all(missing.map(function(handle) {
        return fetch('/products/' + encodeURIComponent(handle) + '.js')
          .then(function(res) { return res.ok ? res.json() : null; })
          .then(function(product) {
            if (product && product.featured_image) {
              map[handle] = product.featured_image;
            }
          })
          .catch(function() { /* ignore single product failures */ });
      })).then(function() {
        applyImageMap(map);
      });
    }

    var handles = [];
    $links.each(function() {
      var handle = this.getAttribute('data-menu-product-handle');
      if (handle && handles.indexOf(handle) === -1) handles.push(handle);
    });

    fetch('/collections/all/products.json?limit=250')
      .then(function(res) { return res.json(); })
      .then(function(data) {
        var map = {};
        (data.products || []).forEach(function(product) {
          if (product.handle && product.images && product.images.length) {
            map[product.handle] = product.images[0].src;
          }
        });
        fetchMissingHandles(map, handles);
      })
      .catch(function() {
        fetchMissingHandles({}, handles);
      });
  }

  function initDesktopMegaMenu() {
    if (window.screen.width <= 1024) return;

    setMegaMenuTop();
    loadMegaMenuProductImages();

    var hideTimer;
    var $grandparent = $('.header--desktop .main-menu > .grandparent');
    var $dropdown = $grandparent.children('.main-menu-dropdown');

    function showMegaMenu() {
      clearTimeout(hideTimer);
      setMegaMenuTop();
      $dropdown.show();
    }

    function hideMegaMenu() {
      hideTimer = setTimeout(function() {
        $dropdown.hide();
      }, 120);
    }

    $grandparent.off('.megaMenu').on('mouseenter.megaMenu', showMegaMenu).on('mouseleave.megaMenu', hideMegaMenu);
    $dropdown.off('.megaMenu').on('mouseenter.megaMenu', showMegaMenu).on('mouseleave.megaMenu', hideMegaMenu);

    $('.header--desktop .main-menu > .grandparent > .main-menu-dropdown > .w1280 > ul > li.parent:first-child').addClass('main-menu--active');
    $('.header--desktop .main-menu-dropdown li.parent').off('.megaMenu').on('mouseenter.megaMenu', function(){
      $(this).addClass('main-menu--active').siblings().removeClass('main-menu--active');
    });

    $(window).off('.megaMenu').on('resize.megaMenu load.megaMenu', setMegaMenuTop).on('scroll.megaMenu', function(){
      if (window.pageYOffset >= 80) {
        clearTimeout(hideTimer);
        $dropdown.hide();
      }
      setMegaMenuTop();
    });
  }

  initDesktopMegaMenu();

  if(window.screen.width <= 1024){
    $(".touch__nav__links li.parent").removeClass("main-menu--active")
    $(".main-menu-dropdown li.parent").click(function(){
      $(this).find(".main-menu-child").slideToggle()
      $(this).addClass("main-menu--active").siblings().removeClass("main-menu--active")
      $(this).siblings().find(".main-menu-child").slideUp()
      $(this).siblings().find(".ariaToggle").attr("aria-expanded",false)
    })
  }
})
